import { appHttpClient } from "../../../installations/http/axiosInterfaces";
import { dedupeRequest } from "../../../installations/http/inFlight";

export const addCategory = (data) => {
  return appHttpClient.post(`/Category/Add`, data);
};

export const updateCategory = (data) => {
  return appHttpClient.post(`/Category/Update`, data);
};

export const updateCategoryImage = (categoryId, data) => {
  return appHttpClient.post(`/Category/Update/Image/${categoryId}`, data, {
    headers: {
      "Content-Type": "multipart/form-data", // Inform the server that this is form data
    },
  });
};

export const deleteCategory = (categoryId) => {
  return appHttpClient.post(`/Category/Delete/${categoryId}`);
};

export const getCategoryById = (categoryId) => {
  // 0016: dedupe StrictMode double-invoke; key on the category id so different categories fetch independently.
  return dedupeRequest(`category:${categoryId}`, () =>
    appHttpClient.get(`/Category/${categoryId}`)
  );
};

export const getCategories = (queryParams) => {
  // 0015: dedupe concurrent identical fetches (StrictMode double-mount) into one network request.
  return dedupeRequest(`categories:${JSON.stringify(queryParams || {})}`, () =>
    appHttpClient.get(`/Category/List`, { params: queryParams })
  );
};

const categoryService = {
  addCategory,
  updateCategory,
  updateCategoryImage,
  deleteCategory,
  getCategoryById,
  getCategories,
};

export default categoryService;


// import { appHttpClient } from "../../../installations/http/axiosInterfaces";

// export const addCategory = (data) => {
//   return appHttpClient.post(`/Category/Add`, data);
// };

// export const updateCategory = (data) => {
//   return appHttpClient.post(`/Category/Update`, data);
// };

// export const updateCategoryImage = (categoryId, data) => {
//   const formData = new FormData();
//   formData.append("file", data);

//   return appHttpClient.post(`/Category/Update/Image`, formData, {
//     params: { id: categoryId },
//     headers: {
//       "Content-Type": "multipart/form-data",
//     },
//   });
// };

// export const deleteCategory = (categoryId) => {
//   return appHttpClient.delete(`/Category/Delete`, {
//     params: { categoryId },
//   });
// };

// export const getCategoryById = (categoryId) => {
//   return appHttpClient.get(`/Category/GetById`, {
//     params: { id: categoryId },
//   });
// };

// export const getCategories = (queryParams) => {
//   return appHttpClient.get(`/Category/List`, {
//     params: queryParams,
//   });
// };

// const categoryService = {
//   addCategory,
//   updateCategory,
//   updateCategoryImage,
//   deleteCategory,
//   getCategoryById,
//   getCategories,
// };

// export default categoryService;
